import Service from '@ember/service';
import AccountLimits from '@dashboard/shared-ui/models/account-limits';
import { ajax } from '@square/dashboard-utilities/utils/xhr';
import { camelize } from '@square/dashboard-utilities/utils/keys';
export const ACCOUNT_LIMITS_ENDPOINT = '/api/v1/account/limits';
export default class AccountLimitsService extends Service {
  makeAccountLimitsRequest(unitToken) {
    const data = unitToken ? {
      unit_token: unitToken
    } : {};
    return ajax(ACCOUNT_LIMITS_ENDPOINT, {
      data
    }, 'GET').then(({
      success,
      limits
    }) => {
      if (!success) {
        throw new Error('There was an error fetching account limits.');
      }
      const {
        currencyCode,
        transactionMaxCents,
        transactionMinCents
      } = camelize(limits);
      return AccountLimits.create({
        currencyCode,
        transactionMaxCents,
        transactionMinCents
      });
    });
  }
}